import classNames from 'classnames'
import { forwardRef } from 'react'
import { TLUiIconType } from '../../../icon-types'

/** @public */
export interface IconProps extends React.HTMLProps<HTMLDivElement> {
	icon: TLUiIconType
	small?: boolean
	children?: undefined
	invertIcon?: boolean
	crossOrigin?: 'anonymous' | 'use-credentials'
}

/** @public */
export const Icon = forwardRef<HTMLDivElement, IconProps>(function Icon(
	{ small, invertIcon, ...props },
	ref
) {
	return (
		<div
			ref={ref}
			{...props}
			className={classNames('tlui-icon', { 'tlui-icon__small': small }, props.className)}
			style={{
				mask: `url(/icons/icon/${props.icon}.svg) center 100% / 100% no-repeat`,
				WebkitMask: `url(/icons/icon/${props.icon}.svg) center 100% / 100% no-repeat`,
				backgroundColor: 'currentcolor',
				transform: invertIcon ? 'scale(-1, 1)' : undefined,
			}}
		/>
	)
})
